/****************************************************************
 * WARNING THIS FILE IS AUTOGENERATED AND SHOULD NOT BE MODIFIED *
 ****************************************************************/
import * as React from "react"
import Svg from "@oui/system/Svg"
type DefaultProps = typeof defaultProps
type SvgProps = React.ComponentPropsWithoutRef<typeof Svg>
type Props = DefaultProps &
  Omit<SvgProps, "fill" | "height" | "stroke" | "viewBox" | "width">
const defaultProps = {
  label: "Topmenu Cloud Shell",
  size: 20
}

const SvgTopmenuCloudShell = ({ size, ...props }: Props) => (
  <Svg
    viewBox="0 0 20 20"
    height={size}
    width={size}
    fill="currentcolor"
    stroke="currentcolor"
    {...props}
  >
    <path
      fill="none"
      strokeLinecap="round"
      strokeMiterlimit={10}
      strokeWidth={1.1}
      d="M11.3 15.3h6"
    />
    <path
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.1}
      d="M3.9 4.6l6 5.3-6 5.4"
    />
  </Svg>
)

SvgTopmenuCloudShell.defaultProps = defaultProps
export default SvgTopmenuCloudShell
